import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'
import React, { useEffect, useMemo, useRef } from 'react'
import { NextSeo } from 'next-seo'
import { NextPageContext } from 'next/dist/shared/lib/utils'
import {
  professionsSearchSelectors,
  professionsSearchThunks,
} from '@ucheba/store/professions/search'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { Store } from 'redux'
import isEqual from '@ucheba/utils/helpers/core/isEqual'
import { IProfSearchPageProps } from './types'
import Custom404 from '../../404.page'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop/ProfSearchPage')),
  touch: dynamic(() => import('./touch/ProfSearchPage')),
}

const ProfSearchPage: NextPage<IProfSearchPageProps> = (props) => {
  const { content, notFound } = props

  const entity = useSelector(professionsSearchSelectors.entity)

  const { query } = useRouter()

  const isRender = useRef(false)

  const lastQuery = useRef(query)

  const dispatch = useDispatch()

  const facetsQuery = useMemo(() => {
    const result = {} as Record<string, any>
    Object.keys(query).forEach((el) => {
      const facetName = el.replace(/[[]]/gm, '')
      result[facetName] = query[el]
    })
    return result
  }, [query])

  useEffect(() => {
    if (isRender.current && !isEqual(lastQuery.current, facetsQuery)) {
      dispatch<any>(
        professionsSearchThunks.fetch({
          data: {
            ...facetsQuery,
            limit: 15,
          },
        })
      )
    } else {
      isRender.current = true
    }
    lastQuery.current = facetsQuery
  }, [dispatch, facetsQuery])

  if (notFound) {
    return <Custom404 />
  }

  return (
    <>
      <NextSeo
        title={content.seo.title}
        description={content.seo.description}
        openGraph={{
          title: content.seo.title,
          description: content.seo.description,
        }}
      />

      {getIDeviceComponent(
        { ...props, content: { ...content, result: entity } },
        devicesPages
      )}
    </>
  )
}

ProfSearchPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store, query } = ctx
  const { dispatch, getState } = store

  const facetsQuery = (() => {
    const result = {} as Record<string, any>
    Object.keys(query).forEach((el) => {
      const facetName = el.replace(/[[]]/gm, '')
      result[facetName] = query[el]
    })
    return result
  })()

  await dispatch(
    professionsSearchThunks.fetch({
      ctx,
      data: {
        ...facetsQuery,
        limit: 15,
      },
    })
  )

  const entity = professionsSearchSelectors.entity(getState())
  const { seo } = entity || {}

  return {
    content: {
      result: entity,
      seo: {
        title: `${seo?.h1} — Учёба.ру` || 'Профессии — Учёба.ру',
        description: seo?.description || 'Профессии - Учеба.ру',
      },
    },
  }
}

export default ProfSearchPage
